var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.855,
    x2: 386.039,
    y1: 416.845,
    y2: 146.661
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd7d7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9981,
    stopColor: "#ffb1b1"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4d4d",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1463,
    stopColor: "#ff4d4d",
    stopOpacity: 0.342
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4d4d",
    stopOpacity: 0
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000068643888896560010720000001649681990609610412_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    xlinkHref: "#lg1",
    y1: 359.468,
    y2: 175.053
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000053535220980308993070000015537254222454624442_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    xlinkHref: "#lg1",
    y1: 464.408,
    y2: 365.742
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080927940767233017780000006213119590254360730_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    xlinkHref: "#lg1",
    y1: 206.985,
    y2: 58.851
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000148649587236469552750000005394273289292140957_",
    gradientUnits: "userSpaceOnUse",
    x1: 366.331,
    x2: 366.331,
    xlinkHref: "#lg1",
    y1: 153.481,
    y2: 48.201
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101073181689873861810000003237445577425150080_",
    gradientUnits: "userSpaceOnUse",
    x1: 145.669,
    x2: 145.669,
    xlinkHref: "#lg1",
    y1: 153.481,
    y2: 48.201
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041253552408227025640000005138232707745718147_",
    gradientUnits: "userSpaceOnUse",
    x1: 88.614,
    x2: 88.614,
    xlinkHref: "#lg1",
    y1: 445.448,
    y2: 265.174
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000094578647477537804680000007906392020381492610_",
    gradientUnits: "userSpaceOnUse",
    x1: 115.986,
    x2: 115.986,
    xlinkHref: "#lg1",
    y1: 468.856,
    y2: 322.36
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000136372843476972260390000001617135106590490002_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.153,
    x2: 142.153,
    xlinkHref: "#lg1",
    y1: 417.193,
    y2: 372.315
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000041253184881724122850000015056091834227345065_",
    gradientUnits: "userSpaceOnUse",
    x1: 423.386,
    x2: 423.386,
    xlinkHref: "#lg1",
    y1: 446.412,
    y2: 266.5
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000022535350846047449670000008499618496257703333_",
    gradientUnits: "userSpaceOnUse",
    x1: 396.014,
    x2: 396.014,
    xlinkHref: "#lg1",
    y1: 470.784,
    y2: 322.76
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062165852728929281890000017737480838226779267_",
    gradientUnits: "userSpaceOnUse",
    x1: 369.847,
    x2: 369.847,
    xlinkHref: "#lg1",
    y1: 416.229,
    y2: 368.346
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m418.604 209.754c-131.042-37.894-246.682-227.968-397.291-4.053-87.39 129.924 115.403 196.753 221.062 209.81 287.099 35.479 343.366-157.425 176.229-205.757z",
    fill: "url(#SVGID_1_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m323.321 324.826c-22.645 0-23.591-33.894-.968-34.896 1.495-.066 3.025-.1 4.59-.1l16.858-5 19.945 5h28.589c3.123 0 5.486 2.825 4.922 5.896-1.831 9.974-10.169 29.1-47.197 29.1z",
    fill: "#4d4dff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m410.944 260.729c.564-3.071-1.799-5.896-4.922-5.896h-28.589l-17.452-5-19.351 5c-50.087 0-64.053 34.996-64.053 34.996h87.17c37.028.001 45.366-19.126 47.197-29.1z",
    fill: "#6c6cff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424.63 225.733c.564-3.071-1.799-5.896-4.922-5.896h-28.589l-19.945-5-16.858 5c-50.087 0-64.053 34.996-64.053 34.996h87.17c37.028 0 45.366-19.127 47.197-29.1z",
    fill: "#8282ff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m438.316 190.736c.564-3.071-1.799-5.896-4.922-5.896h-65.392c-50.087 0-64.053 34.996-64.053 34.996h87.17c37.028.001 45.366-19.126 47.197-29.1z",
    fill: "#9393ff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m188.679 324.826c22.645 0 23.591-33.894.968-34.896-1.495-.066-3.025-.1-4.59-.1l-16.858-5-19.945 5h-28.589c-3.123 0-5.486 2.825-4.922 5.896 1.831 9.974 10.169 29.1 47.197 29.1z",
    fill: "#4d4dff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m101.056 260.729c-.564-3.071 1.799-5.896 4.922-5.896h28.589l17.452-5 19.351 5c50.087 0 64.053 34.996 64.053 34.996h-87.17c-37.028.001-45.366-19.126-47.197-29.1z",
    fill: "#6c6cff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m87.37 225.733c-.564-3.071 1.799-5.896 4.922-5.896h28.589l19.945-5 16.858 5c50.087 0 64.053 34.996 64.053 34.996h-87.17c-37.028 0-45.366-19.127-47.197-29.1z",
    fill: "#8282ff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m73.684 190.736c-.564-3.071 1.799-5.896 4.922-5.896h65.392c50.087 0 64.053 34.996 64.053 34.996h-87.17c-37.028.001-45.366-19.126-47.197-29.1z",
    fill: "#9393ff"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m354.286 352.809h-196.572c-3.146 0-5.695-2.55-5.695-5.695v-121.582c0-3.146 2.55-5.695 5.695-5.695h196.571c3.146 0 5.695 2.55 5.695 5.695v121.582c.001 3.145-2.549 5.695-5.694 5.695z",
    fill: "#ff9c33"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m338.148 262.805v47.036c0 1.559-1.047 2.947-2.56 3.3-7.885 1.832-14.086 8.033-15.906 15.906-.353 1.525-1.741 2.571-3.3 2.571h-120.742c-1.559 0-2.958-1.047-3.311-2.571-1.82-7.873-8.021-14.086-15.906-15.906-1.525-.353-2.571-1.741-2.571-3.3v-47.025c0-1.559 1.047-2.958 2.571-3.311 7.885-1.82 14.086-8.021 15.906-15.906.353-1.525 1.752-2.571 3.311-2.571h120.742c1.559 0 2.947 1.047 3.3 2.571 1.82 7.885 8.021 14.074 15.906 15.906 1.514.353 2.56 1.741 2.56 3.3z",
    fill: "#ffc498"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 286.323,
    fill: "#fa6",
    r: 33.932
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m203.511 282.21h-11.056c-2.761 0-5-2.239-5-5s2.239-5 5-5h11.056c2.761 0 5 2.239 5 5s-2.239 5-5 5z",
    fill: "#ffe7db"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m319.545 291.323h-11.056c-2.761 0-5-2.239-5-5s2.239-5 5-5h11.056c2.761 0 5 2.239 5 5s-2.239 5-5 5z",
    fill: "#ffe7db"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m205.789 262.786c-2.761 0-5-2.239-5-5v-.131c0-2.761 2.239-5 5-5s5 2.239 5 5v.131c0 2.761-2.239 5-5 5z",
    fill: "#ff8a00"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m306.211 310.879c-2.761 0-5-2.239-5-5v-.131c0-2.761 2.239-5 5-5s5 2.239 5 5v.131c0 2.761-2.238 5-5 5z",
    fill: "#ff8a00"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "m264.864 281.323h-3.864v-3.864c0-2.761-2.239-5-5-5s-5 2.239-5 5v3.864h-3.864c-2.761 0-5 2.239-5 5s2.239 5 5 5h3.864v3.864c0 2.761 2.239 5 5 5s5-2.239 5-5v-3.864h3.864c2.761 0 5-2.239 5-5s-2.239-5-5-5z",
    fill: "#ff7300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m433.394 184.84h-65.392c-50.087 0-64.053 34.997-64.053 34.997h-95.898s-13.967-34.997-64.053-34.997h-65.392c-3.122 0-5.486 2.825-4.922 5.896 1.831 9.974 10.169 29.1 47.197 29.1h-28.589c-3.122 0-5.486 2.825-4.922 5.896 1.831 9.973 10.169 29.1 47.197 29.1h-28.589c-3.122 0-5.486 2.825-4.922 5.896 1.831 9.974 10.169 29.1 47.197 29.1h-28.589c-3.123 0-5.486 2.825-4.922 5.896 1.654 9.012 8.628 25.495 37.277 28.589v22.799c0 3.146 2.55 5.695 5.695 5.695h196.571c3.146 0 5.695-2.55 5.695-5.695v-22.799c28.649-3.094 35.622-19.577 37.277-28.589.564-3.071-1.799-5.896-4.922-5.896h-28.589c37.028 0 45.366-19.127 47.197-29.1.564-3.071-1.799-5.896-4.922-5.896h-28.589c37.028 0 45.366-19.127 47.197-29.1.564-3.071-1.799-5.896-4.922-5.896h-28.589c37.028 0 45.366-19.127 47.197-29.1.565-3.071-1.798-5.896-4.921-5.896z",
    fill: "url(#SVGID_00000068643888896560010720000001649681990609610412_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m231.725 379.884v72.618c0 2.761 2.239 5 5 5h38.55c2.761 0 5-2.239 5-5v-72.618c0-2.761-2.239-5-5-5h-38.55c-2.762 0-5 2.239-5 5z",
    fill: "#ff6c6c"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m231.725 379.884v72.618c0 2.761 2.239 5 5 5h38.55c2.761 0 5-2.239 5-5v-72.618c0-2.761-2.239-5-5-5h-38.55c-2.762 0-5 2.239-5 5z",
    fill: "url(#SVGID_00000053535220980308993070000015537254222454624442_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m250.501 69.395-43.844 50.497c-4.09 4.716-.744 12.054 5.499 12.054h19.569v63.575c0 2.761 2.239 5 5 5h38.55c2.761 0 5-2.239 5-5v-63.575h19.569c6.242 0 9.589-7.338 5.499-12.054l-43.844-50.497c-2.906-3.356-8.092-3.356-10.998 0z",
    fill: "#ff6c6c"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m250.501 69.395-43.844 50.497c-4.09 4.716-.744 12.054 5.499 12.054h19.569v63.575c0 2.761 2.239 5 5 5h38.55c2.761 0 5-2.239 5-5v-63.575h19.569c6.242 0 9.589-7.338 5.499-12.054l-43.844-50.497c-2.906-3.356-8.092-3.356-10.998 0z",
    fill: "url(#SVGID_00000080927940767233017780000006213119590254360730_)"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m362.357 57.047-31.685 36.493c-2.956 3.408-.537 8.712 3.974 8.712h14.142v40.339c0 2.761 2.239 5 5 5h25.087c2.761 0 5-2.239 5-5v-40.339h14.142c4.511 0 6.93-5.303 3.974-8.712l-31.685-36.494c-2.101-2.425-5.849-2.425-7.949.001z",
    fill: "#ff6c6c"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m362.357 57.047-31.685 36.493c-2.956 3.408-.537 8.712 3.974 8.712h14.142v40.339c0 2.761 2.239 5 5 5h25.087c2.761 0 5-2.239 5-5v-40.339h14.142c4.511 0 6.93-5.303 3.974-8.712l-31.685-36.494c-2.101-2.425-5.849-2.425-7.949.001z",
    fill: "url(#SVGID_00000148649587236469552750000005394273289292140957_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m141.695 57.047-31.686 36.493c-2.956 3.408-.537 8.712 3.974 8.712h14.142v40.339c0 2.761 2.239 5 5 5h25.087c2.761 0 5-2.239 5-5v-40.339h14.142c4.511 0 6.93-5.303 3.974-8.712l-31.685-36.494c-2.1-2.425-5.848-2.425-7.948.001z",
    fill: "#ff6c6c"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m141.695 57.047-31.686 36.493c-2.956 3.408-.537 8.712 3.974 8.712h14.142v40.339c0 2.761 2.239 5 5 5h25.087c2.761 0 5-2.239 5-5v-40.339h14.142c4.511 0 6.93-5.303 3.974-8.712l-31.685-36.494c-2.1-2.425-5.848-2.425-7.948.001z",
    fill: "url(#SVGID_00000101073181689873861810000003237445577425150080_)"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m88.614 440.187c-2.761 0-5-2.239-5-5v-154.977c0-2.761 2.239-5 5-5s5 2.239 5 5v154.977c0 2.761-2.239 5-5 5z",
    fill: "#b2b2ff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m88.614 440.187c-2.761 0-5-2.239-5-5v-154.977c0-2.761 2.239-5 5-5s5 2.239 5 5v154.977c0 2.761-2.239 5-5 5z",
    fill: "url(#SVGID_00000041253552408227025640000005138232707745718147_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m115.986 464.026c-2.761 0-5-2.239-5-5v-123.055c0-2.761 2.239-5 5-5s5 2.239 5 5v123.055c0 2.761-2.238 5-5 5z",
    fill: "#b2b2ff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m115.986 464.026c-2.761 0-5-2.239-5-5v-123.055c0-2.761 2.239-5 5-5s5 2.239 5 5v123.055c0 2.761-2.238 5-5 5z",
    fill: "url(#SVGID_00000094578647477537804680000007906392020381492610_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m142.153 410.593c-2.761 0-5-2.239-5-5v-23.086c0-2.761 2.239-5 5-5s5 2.239 5 5v23.086c0 2.761-2.238 5-5 5z",
    fill: "#b2b2ff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m142.153 410.593c-2.761 0-5-2.239-5-5v-23.086c0-2.761 2.239-5 5-5s5 2.239 5 5v23.086c0 2.761-2.238 5-5 5z",
    fill: "url(#SVGID_00000136372843476972260390000001617135106590490002_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m423.386 440.187c-2.761 0-5-2.239-5-5v-154.977c0-2.761 2.239-5 5-5s5 2.239 5 5v154.977c0 2.761-2.239 5-5 5z",
    fill: "#b2b2ff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m423.386 440.187c-2.761 0-5-2.239-5-5v-154.977c0-2.761 2.239-5 5-5s5 2.239 5 5v154.977c0 2.761-2.239 5-5 5z",
    fill: "url(#SVGID_00000041253184881724122850000015056091834227345065_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m396.014 464.026c-2.761 0-5-2.239-5-5v-123.055c0-2.761 2.239-5 5-5s5 2.239 5 5v123.055c0 2.761-2.239 5-5 5z",
    fill: "#b2b2ff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m396.014 464.026c-2.761 0-5-2.239-5-5v-123.055c0-2.761 2.239-5 5-5s5 2.239 5 5v123.055c0 2.761-2.239 5-5 5z",
    fill: "url(#SVGID_00000022535350846047449670000008499618496257703333_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m369.847 410.593c-2.761 0-5-2.239-5-5v-23.086c0-2.761 2.239-5 5-5s5 2.239 5 5v23.086c0 2.761-2.239 5-5 5z",
    fill: "#b2b2ff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m369.847 410.593c-2.761 0-5-2.239-5-5v-23.086c0-2.761 2.239-5 5-5s5 2.239 5 5v23.086c0 2.761-2.239 5-5 5z",
    fill: "url(#SVGID_00000062165852728929281890000017737480838226779267_)"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m455.089 143.067c-2.761 0-5-2.239-5-5 0-3.492-2.841-6.333-6.333-6.333-2.761 0-5-2.239-5-5s2.239-5 5-5c3.492 0 6.333-2.841 6.333-6.333 0-2.761 2.239-5 5-5s5 2.239 5 5c0 3.492 2.841 6.333 6.333 6.333 2.761 0 5 2.239 5 5s-2.239 5-5 5c-3.492 0-6.333 2.841-6.333 6.333 0 2.761-2.239 5-5 5z",
    fill: "#ff9c33"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m50.636 309.53c-2.761 0-5-2.239-5-5 0-3.492-2.841-6.333-6.333-6.333-2.761 0-5-2.239-5-5s2.239-5 5-5c3.492 0 6.333-2.841 6.333-6.333 0-2.761 2.239-5 5-5s5 2.239 5 5c0 3.492 2.841 6.333 6.333 6.333 2.761 0 5 2.239 5 5s-2.239 5-5 5c-3.492 0-6.333 2.841-6.333 6.333 0 2.762-2.239 5-5 5z",
    fill: "#ff6c6c"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m180.474 455.836c-1.28 0-2.559-.488-3.536-1.464l-5.464-5.464-5.464 5.464c-1.953 1.952-5.118 1.952-7.071 0-1.953-1.953-1.953-5.119 0-7.071l9-9c1.953-1.952 5.118-1.952 7.071 0l9 9c1.953 1.953 1.953 5.119 0 7.071-.977.976-2.257 1.464-3.536 1.464z",
    fill: "#ff9c33"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m437.386 66.974c-1.28 0-2.559-.488-3.536-1.464l-5.464-5.464-5.464 5.464c-1.953 1.952-5.118 1.952-7.071 0-1.953-1.953-1.953-5.119 0-7.071l9-9c1.953-1.952 5.118-1.952 7.071 0l9 9c1.953 1.953 1.953 5.119 0 7.071-.977.975-2.256 1.464-3.536 1.464z",
    fill: "#6c6cff"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m338.374 430.998c-1.28 0-2.559-.488-3.536-1.464l-5.464-5.464-5.464 5.464c-1.953 1.952-5.118 1.952-7.071 0-1.953-1.953-1.953-5.119 0-7.071l9-9c1.953-1.952 5.118-1.952 7.071 0l9 9c1.953 1.953 1.953 5.119 0 7.071-.977.976-2.256 1.464-3.536 1.464z",
    fill: "#6c6cff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.0bdbd2961bb43dbc25b58bbe63f42902.svg";
export { ForwardRef as ReactComponent };